import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getRandomSleeve } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";

class RandomSleeveContainer extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { pathName: nextPath } = nextProps;
    const { pathName } = this.props;
    if (nextPath !== pathName) {
      this.props.request();
    }
  }
  render = () => {
    const { data, loading, failure, render, pathName } = this.props;
    const sleeve = (data && data.data) || [];
    if (loading) {
      return <Skeleton count={3} />;
    }
    // if (!loading && sleeves.length === 0) {
    //   return null;
    // }
    return render({ sleeve, loading, failure });
  };
}

export default CreateContainer(getRandomSleeve, RandomSleeveContainer);
